import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import * as serviceWorker from './serviceWorker';
import {Provider} from 'react-redux';
import configureStore, {history} from 'store';
import EnhancedRouter from 'router';
import routes from 'router/routes';

const store = configureStore();

ReactDOM.render(
  <Provider store={store}>
    <EnhancedRouter history={history} routes={routes(store)} />
  </Provider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
